import { SelectField, SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';

const inspectionCompanies = [
  { label: 'Snap Draw', value: 'Self Inspection' },
  { label: 'CFSI', value: 'CFSI' },
  { label: 'OMNI/TJ', value: 'OMNI/TJ' },
  { label: 'NOVA', value: 'NOVA' },
  { label: 'CBRE', value: 'CBRE' },
  { label: 'TPO/Borrower Provided Inspection', value: 'TPO/Borrower Provided Inspection' }
];

export const StartInspectionProcess = observer(({ loanId, drawId, afterActionExecuted, isSnapDrawEligible }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.sendDrawInspectionEmail(drawId, afterActionExecuted);
  }

  const filteredInspectionCompanies = useMemo(() => {
    return isSnapDrawEligible
      ? inspectionCompanies
      : inspectionCompanies.filter(option => option.value !== 'Self Inspection');
  }, [isSnapDrawEligible]);

  useEffect(() => {
    drawActionsStore.setInspectionCompany(filteredInspectionCompanies[0].value);
  }, []);

  return (
    <SubmitDialog
      title="Please Select an Inspection Company"
      open={drawActionsStore.isStartInspectionProcessDialogOpen}
      body={
        <>
          <SelectField
            options={filteredInspectionCompanies}
            testId={'inspectionCompany'}
            value={drawActionsStore.inspectionCompany}
            onChange={value => drawActionsStore.setInspectionCompany(value)}
            fullWidth
            variant="outlined"
          />
        </>
      }
      handleClose={() => drawActionsStore.setIsStartInspectionProcessDialogOpen(false)}
      handleOk={confirmHandler}
      cancelButtonText='Cancel'
    />
  );
});
